<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>
                            Tra cứu, tìm kiếm nhật ký đồng bộ dữ liệu
                        </strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Type:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 class="form-control"
                                             :options="listTypes"
                                             allowClear="true"
                                             v-model="searchParams.indexName"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="5" v-if="!seen">
                                <b-form-group label="Uuid:"
                                              label-for="input-Uid"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input id="input-Uid" v-model="searchParams.uuid"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="3">
                                <b-button variant="primary" id="seen" v-on:click="showHideAdvanceSearch">{{ seen ? 'Tìm kiếm nâng cao' : 'Tìm kiếm nhanh' }}</b-button>
                            </b-col>
                        </b-row>
                        <br />
                        <div class="showandhide" v-if="seen">
                            <b-row>
                                <b-col md="4">
                                    <b-form-radio id="anc" class="radio" name="dv" v-model="selected" value="1" style="float: left"></b-form-radio>
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="User đồng bộ:"
                                                  label-for="input-dv-dongbo">
                                        <b-form-input id="input-dv-dongbo" :disabled="selected != '1'" v-model="searchParams.syncUserName" style="width: 250px;"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-radio class="radio" name="dv" v-model="selected" value="2" style="float: left"></b-form-radio>
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="Mã đơn vị:"
                                                  label-for="input-mats">
                                        <b-form-input id="input-mats" :disabled="selected != '2'" v-model="searchParams.tCode" style="width: 250px;"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-radio class="radio" name="dv" v-model="selected" value="3" style="float: left"></b-form-radio>
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="Cán bộ SD:"
                                                  label-for="input-cbsd">
                                        <b-form-input id="input-cbsd" :disabled="selected != '3'" v-model="searchParams.userInUse" style="width: 250px;"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <b-form-radio id="anc1" class="radio" name="tsqg" v-model="selected1" value="4" style="float: left"></b-form-radio>
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="Mã TSQG:"
                                                  label-for="input-tsqg">
                                        <b-form-input id="input-tsqg" :disabled="selected1 != '4'" v-model="searchParams.assetCode" style="width: 250px;"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-radio class="radio" name="tsqg" v-model="selected1" value="5" style="float: left"></b-form-radio>
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="Mã báo cáo:"
                                                  label-for="input-mabc">
                                        <b-form-input id="input-mabc" :disabled="selected1 != '5'" v-model="searchParams.reportCode" style="width: 250px;"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-radio class="radio" name="tsqg" v-model="selected1" value="6" style="float: left"></b-form-radio>
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="Mã danh mục:"
                                                  label-for="input-madanhmuc">
                                        <b-form-input id="input-madanhmuc" :disabled="selected1 != '6'" v-model="searchParams.categoryCode" style="width: 250px;"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="Từ ngày:"
                                                  label-for="input-horizontal">
                                        <span>
                                            <date-picker style="width: 250px; margin-left:17px" v-model="searchParams.categoryCode" placeholder="dd/mm/yyyy"></date-picker>
                                        </span>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-group id="fieldset-horizontal"
                                                  :label-cols="4"
                                                  label="Đến ngày:"
                                                  label-for="input-horizontal">
                                        <span>
                                            <date-picker style="width: 250px; margin-left:17px" v-model="searchParams.endDate" placeholder="dd/mm/yyyy"></date-picker>
                                        </span>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <b-form-radio class="radio" name="status-rdo" v-model="searchParams.status" value="">
                                        Tất cả
                                    </b-form-radio>
                                </b-col>
                                <b-col md="4">
                                    <b-form-radio class="radio" name="status-rdo" v-model="searchParams.status" value="success">
                                        Thành công
                                    </b-form-radio>
                                </b-col>
                                <b-col md="4">
                                    <b-form-radio class="radio" name="status-rdo" v-model="searchParams.status" value="fail">
                                        Thất bại
                                    </b-form-radio>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row class="text-center">
                            <b-col sm="12">
                                <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchParams"
                            :gridOptions="gridOptions"
                            :showActions="false"
                            gridName="Danh sách nhật ký đồng bộ dữ liệu"
                            aipType="syncApi"
                            :dataUrl="$services.API_SYNC_DATA_ENPOINT + 'searchLogs/searchingLogs'"
                            :pagination-normalize="normalizePagination"
                            :result-normalize="normalizeResult"
                            ref="analysisLogTable">
                        <template v-slot:cell(message)="row">
                            <span v-html="getMessageResult(row.item.message)"></span>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<style>
    .radio {
        float: left;
        margin-top: 7px;
    }
</style>
<script>
    export default {
        data() {
            return {
                listTypes: [
                    { id: 'logs-wsts2', text: 'Báo cáo', value: 'logs-wsts2' },
                    { id: 'logs-wsts2', text: 'Tài sản', value: 'logs-wsts2' },
                    { id: 'logs-ms-category', text: 'Danh mục', value: 'logs-ms-category' }
                ],
                gridOptions: {
                    fields: [
                        { key: 'layer', label: 'Layer' },
                        { key: 'syncDate', label: 'Thời gian', thAttr: { width: 120 } },
                        { key: 'status', label: 'Trạng thái', thAttr: { width: 120 } },
                        { key: 'info', label: 'Thông báo', thAttr: { width: 100 } },
                        { key: 'message', label: 'Dữ liệu' }
                    ]
                },
                searchParams: {
                    indexName: "",
                    uuid: "",
                    syncUserName: "",
                    tCode: "",
                    userInUse: "",
                    assetCode: "",
                    reportCode: "",
                    categoryCode: "",
                    fromDate: "",
                    endDate: "",
                    status: ""
                },
                selected: '',
                selected1: '',
                seen: false
            }
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.analysisLogTable.refresh();
            },
            normalizeResult(grid, response) {
                grid.options.totalRows = response.totalRows;

                return response.results;
            },
            normalizePagination(options) {
                return {
                    currentPage: options.page,
                    pageSize: options.itemsPerPage
                };
            },
            showHideAdvanceSearch: function () {
                this.seen = !this.seen;

                if (!this.seen) {
                    this.resetAdvanceSearch()
                } else {
                    this.searchParams.uuid = "";
                }

            },
            resetAdvanceSearch: function () {
                this.searchParams.syncUserName = "";
                this.searchParams.tCode = "";
                this.searchParams.userInUse = "";
                this.searchParams.assetCode = "";
                this.searchParams.reportCode = "";
                this.searchParams.categoryCode = "";
                this.searchParams.fromDate = "";
                this.searchParams.endDate = "";
                this.searchParams.status = "";
            },
            getMessageResult(message) {
                try {
                    return '<pre><code>' + JSON.stringify(JSON.parse(message), null, 2) + '</code></pre>';
                } catch {
                    return message;
                }
            }
        }
    }
</script>
